var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmbr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 75,
    viewBox: "0 0 95 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 37.5C69 54.897 54.897 69 37.5 69C20.103 69 6 54.897 6 37.5C6 20.103 20.103 6 37.5 6C54.897 6 69 20.103 69 37.5Z",
    fill: "white",
    stroke: "#2C4245",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4591 51H41.0671V27.672H33.3551V31.8H36.4591V51Z",
    fill: "#32474A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36.2679C93.3333 37.0378 93.3333 38.9622 92 39.732L72.5 50.9904C71.1667 51.7602 69.5 50.7979 69.5 49.2583L69.5 26.7417C69.5 25.2021 71.1667 24.2398 72.5 25.0096L92 36.2679Z",
    fill: "#2C4245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmbr);
export default __webpack_public_path__ + "static/media/nmbr.c6c99a2af259c3912485942f8913b8e4.svg";
export { ForwardRef as ReactComponent };